<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: []
            }
        },
        mounted() {
            if(this.adminOnly()) {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/pharmacies/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/pharmacies/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Описание',
                        url: `/pharmacies/${this.$route.params.id}/description`,
                    },
                    {
                        title: 'Категории',
                        url: `/pharmacies/${this.$route.params.id}/categories`,
                    },
                    {
                        title: 'Лекарства',
                        url: `/pharmacies/${this.$route.params.id}/drugs`,
                    },
                    {
                        title: 'Акции',
                        url: `/pharmacies/${this.$route.params.id}/promotions`,
                    },
                    {
                        title: 'Импорт',
                        url: `/pharmacies/${this.$route.params.id}/import`,
                    },
                    {
                        title: 'Доставка',
                        url: `/pharmacies/${this.$route.params.id}/delivery`,
                    },
                    {
                        title: 'Перенаправление доставки',
                        url: `/pharmacies/${this.$route.params.id}/delivery-address-redirect`
                    },
                ]
            } else {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/pharmacies/${this.$route.params.id}`,
                    },
                    {
                        title: 'Описание',
                        url: `/pharmacies/${this.$route.params.id}/description`,
                    },
                    {
                        title: 'Категории',
                        url: `/pharmacies/${this.$route.params.id}/categories`,
                    },
                    {
                        title: 'Лекарства',
                        url: `/pharmacies/${this.$route.params.id}/drugs`,
                    },
                ]
            }
        },
        methods: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        }
    };
</script>
